<div class="signature-wrapper">
  <canvas #canvas class="signature-canvas" tabindex="0"></canvas>
</div>